var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-1"},[_c('div-table',{attrs:{"config":_vm.configList,"idWharhouse":_vm.idWharhouse,"currentUser":_vm.currentUser,"data":_vm.warehouses,"loading":_vm.loading,"paginate":_vm.paginate},on:{"reset":_vm.reset,"refresh":_vm.refresh,"filtrer":_vm.filtrer,"search":_vm.search,"paginatation":_vm.paginatation}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }